import layout from "../../constants/layout";
import NavDrawer from "../NavDrawer";
import NavBar from "../NavBar";
import { useEffect, useState } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useNavContext } from "../../context/NavContext";
import { ALWAYS_TEMPORARY } from "../NavDrawer/NavDrawer";
import {
  INSTALL_SUGGESTION_SESSION_KEY,
  shouldSuggestInstall,
} from "../../utils/pwaInstall";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

function AppLayout({
  navlinkSections,
  appTitle,
  children,
  injectedComponents,
}) {
  const [navDrawerOpen, setNavDrawerOpen] = useState(false);
  const [showInstallPrompt, setShowInstallPrompt] = useState(false);
  const isLgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));
  const { isNavDisabled } = useNavContext();
  const marginLeft =
    isLgUp && !isNavDisabled && !ALWAYS_TEMPORARY ? layout.navDrawerWidth : 0;
  const { palette } = useTheme();

  useEffect(() => {
    document.getElementsByTagName(
      "title"
    )[0].textContent = `${appTitle} | Outliers ACT Prep`;
  }, [appTitle]);

  useEffect(() => {
    const shouldShowInstallPrompt = shouldSuggestInstall();
    if (!shouldShowInstallPrompt) {
      return;
    }

    const wasDismissedThisSession =
      window.sessionStorage.getItem(INSTALL_SUGGESTION_SESSION_KEY) === "true";

    if (!wasDismissedThisSession) {
      setShowInstallPrompt(true);
    }
  }, []);

  const handleDismissInstallPrompt = () => {
    window.sessionStorage.setItem(INSTALL_SUGGESTION_SESSION_KEY, "true");
    setShowInstallPrompt(false);
  };

  const handleGoToInstall = () => {
    window.sessionStorage.setItem(INSTALL_SUGGESTION_SESSION_KEY, "true");
    window.location.assign("/install/");
  };

  return (
    <Box
      sx={{
        height: "100dvh",
        overflowY: "hidden",
        overflowX: "hidden",
        scrollbarWidth: "auto",
        backgroundColor: palette.background.default,
      }}
    >
      <NavBar
        navDrawerOpen={navDrawerOpen}
        setNavDrawerOpen={setNavDrawerOpen}
        appTitle={appTitle}
      />
      <NavDrawer
        open={navDrawerOpen}
        setOpen={setNavDrawerOpen}
        navlinkSections={navlinkSections}
        variant={isLgUp ? "permanent" : "temporary"}
      />
      <Dialog open={showInstallPrompt} onClose={handleDismissInstallPrompt}>
        <DialogTitle>Install Outliers on your phone</DialogTitle>
        <DialogContent>
          <DialogContentText>
            You are using Outliers in a mobile browser. Installing the app gives
            you faster access from your home screen and a better app-like
            experience.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDismissInstallPrompt}>Not now</Button>
          <Button onClick={handleGoToInstall} variant="contained">
            Go to install page
          </Button>
        </DialogActions>
      </Dialog>
      {injectedComponents}
      <Grid
        container
        sx={{
          padding: "0 1rem",
          marginLeft: `${marginLeft}rem`,
          width: `calc(100vw - ${marginLeft}rem)`,
          height: `100%`,
          overflowY: "auto",
          overflowX: "hidden",
          boxSizing: "border-box",
        }}
      >
        {children}
      </Grid>
    </Box>
  );
}

export default AppLayout;
